import React from 'react';
export function Navbar() {
  return <nav className="w-full py-6 px-8 md:px-16 flex flex-col md:flex-row justify-between items-center relative z-20" data-id="element-15">
      {/* Logo Area */}
      <div className="flex flex-col items-center md:items-start mb-6 md:mb-0 cursor-pointer" data-id="element-16">
        <div className="relative flex items-center" data-id="element-17">
          {/* Stylized Swoosh SVG */}
          <svg className="absolute -left-12 -top-4 w-28 h-20 text-white opacity-90" viewBox="0 0 100 60" fill="none" stroke="currentColor" strokeWidth="1.5" data-id="element-18">
            <path d="M10,40 C30,10 70,10 90,30" strokeDasharray="4 2" data-id="element-19" />
            <path d="M5,45 C25,15 75,15 95,35" strokeWidth="2" data-id="element-20" />
            <path d="M0,50 C20,20 80,20 100,40" strokeWidth="1" opacity="0.5" data-id="element-21" />
          </svg>
          <span className="text-4xl md:text-5xl font-bold text-white tracking-widest z-10 drop-shadow-md" data-id="element-22">
            LSPM
          </span>
        </div>
        <span className="text-white text-xs md:text-sm tracking-widest mt-1 ml-1 opacity-90" data-id="element-23">
          Keeping Your Doors Open
        </span>
      </div>

      {/* Navigation Links */}
      <div className="flex flex-wrap justify-center items-center gap-6 md:gap-8 mb-6 md:mb-0" data-id="element-24">
        <a href="#" className="text-white hover:text-gray-300 transition-colors text-lg" data-id="element-25">
          Temp
        </a>
        <a href="#" className="text-white hover:text-gray-300 transition-colors text-lg" data-id="element-26">
          Warehouse
        </a>
        <a href="#" className="text-white hover:text-gray-300 transition-colors text-lg" data-id="element-27">
          Industrial Staffing
        </a>
        <a href="#" className="text-[#5a9e3f] hover:text-[#4a8233] transition-colors text-lg" data-id="element-28">
          Job Listings
        </a>
      </div>

      {/* CTA Button */}
      <button className="bg-[#5a9e3f] hover:bg-[#4a8233] text-white px-6 py-2.5 rounded font-medium transition-colors shadow-lg" data-id="element-29">
        Contact Us
      </button>
    </nav>;
}